export enum ProductListFilterEnum {
    Category = 'category',
    Brand = 'brand',
    SubBrand = 'subBrand',
    Color = 'color',
    Material = 'material',
    Status = 'status',
    Availability = 'availability',
    SuggestedRetailPrice = 'suggestedRetailPrice',
    Width = 'width',
    Height = 'height',
    Length = 'length',
    Diameter = 'diameter',
    Weight = 'weight',
    Shape = 'shape',
    NumberOfIndividuals = 'numberOfIndividuals',
    SeatingComfort = 'seatingComfort',
    Pattern = 'pattern',
    IsFsc = 'isFsc',
    IsAssemblyRequired = 'isAssemblyRequired',
    Is3DModelAvailable = 'is3DModelAvailable',
}

export const PRODUCT_LIST_FILTERS_ORDER_CONFIG: ProductListFilterEnum[] = [
    ProductListFilterEnum.Category,
    ProductListFilterEnum.Brand,
    ProductListFilterEnum.SubBrand,
    ProductListFilterEnum.Color,
    ProductListFilterEnum.Material,
    ProductListFilterEnum.Status,
    ProductListFilterEnum.Availability,
    ProductListFilterEnum.SuggestedRetailPrice,
    ProductListFilterEnum.Width,
    ProductListFilterEnum.Height,
    ProductListFilterEnum.Length,
    ProductListFilterEnum.Diameter,
    ProductListFilterEnum.Weight,
    ProductListFilterEnum.Shape,
    ProductListFilterEnum.NumberOfIndividuals,
    ProductListFilterEnum.SeatingComfort,
    ProductListFilterEnum.Pattern,
    ProductListFilterEnum.IsFsc,
    ProductListFilterEnum.IsAssemblyRequired,
    ProductListFilterEnum.Is3DModelAvailable,
]

export const filtersConfigForDiningTables = [
    ProductListFilterEnum.Shape,
    ...PRODUCT_LIST_FILTERS_ORDER_CONFIG.filter(filter => filter !== ProductListFilterEnum.Shape),
]
